export default __webpack_public_path__ + "static/media/bag.3d9884e6.svg";